module.exports = __webpack_public_path__ + "img/frogero_app_mock_small.dd13e65e.webp";